import { useEffect, useRef, useState } from 'react';
import SocialIcons from '../molecules/SocialIcons';
import './styles/Footer.css';

const Footer = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sentinelRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
            setIsVisible(true);
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            {
                root: null,
                threshold: 0.1,
            }
        );

        if (sentinelRef.current) {
            observer.observe(sentinelRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <footer className="footer">
            <div ref={sentinelRef} className="footer__lazy-sentinel" />
            {isVisible ? (
                <div className="container footer__inner">
                    <p className="footer__text">© {new Date().getFullYear()} Sergio Beleño. Built with React & Contentful.</p>
                    <SocialIcons />
                </div>
            ) : null}
        </footer>
    );
};

export default Footer;
